<template>
    <div class="scroll-notice" v-if="notices.length > 0">
        <div class="notice-content">
            <div class="notice-tag">公告通知</div>
            <div class="notice-text" ref="noticeText">
                <div v-for="(notice, index) in notices"
                     :key="index"
                     class="notice-item"
                     @click="handleNoticeClick(notice)">
                    {{ notice.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { articleLists } from '@/api/index';
import { useRouter } from 'vue-router/composables';

// 通知内容数组
const notices = ref([]);
const router = useRouter();
const noticeText = ref(null);
let animationTimer = null;

const handleNoticeClick = (notice) => {
    if (notice.wechatUrl) {
        window.open(notice.wechatUrl, '_blank');
    } else {
        router.push('/information/detail?id=' + notice.id);
    }
};
// 启动滚动动画
const startScroll = () => {
    if (!noticeText.value || notices.value.length <= 1) return;
    console.log('noticeText.value', noticeText.value);
    
    // 等待DOM完全渲染
    setTimeout(() => {
        const containerHeight = noticeText.value.parentElement.offsetHeight;
        let currentIndex = 0;
        const showNextNotice = () => {
            // 计算当前通知的位置，让当前通知居中显示
            const position = -currentIndex * containerHeight;
            noticeText.value.style.transform = `translateY(${position}px)`;
            // 3秒后显示下一条通知
            setTimeout(() => {
                currentIndex = (currentIndex + 1) % notices.value.length;
                showNextNotice();
            }, 3000);
        };
        // 开始显示第一条通知
        showNextNotice();
    }, 500);
};

// 停止滚动动画
const stopScroll = () => {
    if (animationTimer) {
        cancelAnimationFrame(animationTimer);
        animationTimer = null;
    }
};

onMounted(() => {
    const data = {
        pageNo: 1,
        pageSize: 100,
        categoryId: 15
    };
    articleLists(data).then(({ data }) => {
        const _data = data?.list || [];
        notices.value = _data;
    });
    // 延迟启动滚动，确保DOM已渲染
    setTimeout(() => {
        startScroll();
    }, 1000);
});

onUnmounted(() => {
    stopScroll();
});
</script>

<style scoped lang="scss">
.scroll-notice {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 67px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  .notice-content {
    flex: 1;
    overflow: hidden;
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: 40px;
    overflow: hidden;
    .notice-tag {
    
        width: 108px;
        height: 40px;
        text-align: center;
        font-size: 14px;
        line-height: 40px;
        margin-right: 12px;
        background:#8b2b2e;
        color: #fff;
        border-radius: 20px;
    }
    .notice-text {
        display: flex;
        flex-direction: column;
        position: relative;
        transition: transform 0.5s ease-in-out;
        overflow: hidden;
        cursor: pointer;
        .notice-item {
            height: 40px;
            font-size: 14px;
            font-weight: 500;
            line-height: 40px;
            flex-shrink: 0;
            white-space: nowrap;
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }
    }
  }
}
</style>
